import API from '@/config/api'
import axios from 'axios'

export const GET_NOTIFICATIONS = (params = {}) =>
  axios.get(API.teacher.notifications.all, { params })

export const READ_NOTIFICATION = id =>
  axios.put(API.teacher.notifications.one.replace('$id', id))

export const GET_TEACHER_STUDENTS = (params = {}) => axios.get(API.teacher.students.all, { params })
export const GET_CARDS = (params = {}) => axios.get(API.teacher.cards.all, { params })
export const GET_CARD_EVENTS = (params = {}) => axios.get(API.teacher.cards.events, { params })
export const GET_PASSAGE_HISTORY = (params = {}) => axios.get(API.teacher.passages, { params })
export const GET_CLASSES_SUGGESTIONS = (params = {}) => axios.get(API.teacher.suggestions.classes, { params })
export const UDATE_PARENT_OFERTA = (id, parentId, state) =>
  axios.patch(API.teacher.students.parent.replace('$id', id).replace('$parent_id', parentId), {
    is_oferta_accepted: state
  })

export const REQUEST_REPORT_ISSUED_CARDS = params =>
  axios.post(API.teacher.reports.issued_cards, {...params})

export const REQUEST_REPORT_BLOCKED_CARDS = params =>
  axios.post(API.teacher.reports.blocked_cards, {...params})

export const REQUEST_REPORT_PASSAGES = params =>
  axios.post(API.teacher.reports.passages, {...params})

export const REQUEST_REPORT_EXTENDED_CARDS = params =>
  axios.post(API.teacher.reports.extended_cards, {...params})

export const REQUEST_REPORT_DENIED_PASSAGES = params =>
  axios.post(API.teacher.reports.denied_passages, {...params})

export const REQUEST_REPORT_PRESENCE = params =>
  axios.post(API.teacher.reports.presence, {...params})

export const GET_REPORT_STATUS = guid =>
  axios.get(API.teacher.reports.status.replace('$guid', guid))

export const DOWNLOAD_REPORT = guid =>
  axios.get(API.teacher.reports.download.replace('$guid', guid))